export default "__VITE_ASSET__DTdgT6RA__"